const requiredFieldsSeven = ["essay"];

export default requiredFieldsSeven;
